import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigService } from "@core/services/config.service";
import { Observable } from "rxjs";
import { CustomerFeedback } from "@shared/models/CustomerFeedback";
import { EmailValidationResponse } from "@shared/models/email-validation-response";

@Injectable({
  providedIn: 'root'
})
export class CustomerExperienceApiService {

  constructor(public http: HttpClient, private config: ConfigService) {
  }

  get baseUrl(): string {
    return `${this.config.getCurrent().services.experience}/api/customer`;
  }

  public addCustomerFeedback(customerFeedback: CustomerFeedback): Observable<CustomerFeedback> {
    return this.http.post<CustomerFeedback>(`${this.baseUrl}/feedback`, customerFeedback);
  }

  public getEmailValidation(email: string, source: string = null): Observable<EmailValidationResponse> {
    const params = new HttpParams()
      .append('email', email)
      .append('source', source)
    return this.http.get<EmailValidationResponse>(`${this.baseUrl}/validateEmail`, { params });
  }
}
